/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-08 15:41:05
 * @LastEditors: caiqin.xie
 * @message: bolg组件
 */
import React from "react";
import { IBlogItem } from '@/common/types'
import LazyMedia from "@/components/LazyMedia";
import "./index.module.scss";

interface IblogProps {
  type: string; // main==>图两列文1列  normal==>图1列文两列  simple==>没有标题和内容  noContent==>没有内容 onlyTitle==>只有标题
  blogData: IBlogItem; // 博客数据
  className?: string; // 组件类名
  picClassName?: string; // 图片类名
  itemClassName?: string; // 内容类名
}

const BlogItem = (props: IblogProps) => {
  const {type, blogData, className, picClassName, itemClassName} = props
  return (
    <div className={`blog-list-item ${className}`}>
      <div className={`blog-pic ${picClassName}`}>
        <LazyMedia type="image" LazyClassName="full-wh" src={blogData?.cover} alt={blogData?.coverAlt} />
      </div>
      <div className={`blog-item ${itemClassName}`}>
        {(type !== 'simple') && (
            <h3 className="blog-item-title">{blogData?.title}</h3>
        )}
        {(type === 'main' || type === 'normal') && (
            <p className="blog-item-content" title={blogData?.briefIntroduction}>{blogData?.briefIntroduction}</p>
        )}
        {(type !== 'onlyTitle') && (
          <div className="blog-itm-author">
            <p className="blog-author-info">
              {blogData && blogData.headImage && (
                <img src={blogData?.headImage} alt={blogData?.headImageAlt} />
              )}
              <span className="blog-itm-author-name">{blogData?.publisher}</span>
            </p>
            <p className="blog-itm-desc">{blogData?.personalizedSignature}</p>
          </div>
        )}
      </div>
    </div>
  )
}
export default BlogItem
